/**
 * Map Legend Plugin for Search Results Map
 *
 * Manages the visibility and content of map legend panels based on:
 * - Product type (Communities, Homes, etc.)
 * - Map zoom level
 * - Interactive site plan availability
 *
 * Switches between pin legend and ISM legend at zoom >= 16 when interactive site plans are available.
 *
 * DOM expectations:
 * - [data-map-legend]: Main legend container
 * - [data-map-legend-title]: Title span that changes between "Legend" and "Plans & Homes"
 * - [data-map-legend="pins"]: Pin legend panel
 *
 * Reason to change: how the legend visibility and content should respond to
 * product type, zoom level, or interactive site plan availability.
 *
 * @module searchResultsMap/plugins/mapLegend.plugin
 */

import createMapLegendElement from '../components/mapLegend';

export default function createMapLegendPlugin() {
  const state = {
    started: false,
    subscriptions: [],
    mapFacade: null,
    store$: null,
  };

  function mountLegendComponent(context) {
    if (!context.root) {
      return false;
    }
    
    state.legendRootElement = createMapLegendElement();
    context.root.insertAdjacentElement('beforebegin', state.legendRootElement);

    return true;
  }

  function clearSubscriptions() {
    state.subscriptions.forEach((subscription) => subscription?.unsubscribe?.());
    state.subscriptions = [];
  }

  return {
    name: 'map-legend',

    async init(context) {
      context.state.mapLegend = {
        started: false,
      };
    },

    async start(context) {
      if (state.started) {
        return;
      }

      state.store$ = context.services.store$;
      state.mapFacade = context.services.mapFacade;

      if (!state.store$ || !state.mapFacade) {
        return;
      }

      const mounted = mountLegendComponent(context);

      if (!mounted) {
        return;
      }

      state.started = true;
      context.state.mapLegend = {
        started: true,
      };
    },

    async stop(context) {
      clearSubscriptions();

      state.started = false;
      state.mapFacade = null;
      state.store$ = null;

      delete context.state.mapLegend;
    },
  };
}
